import { BreadcrumbProps } from 'packages/common-frontend/components/Breadcrumbs';

export const portfolioOverviewBreadcrumb: BreadcrumbProps = {
  label: 'Portfolio',
  path: '/portfolio/overview/facilities',
};
